import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Document } from "../../models/document.model";
import { LocaleObserver } from "../../observers/locale.observer";
import { DocumentService } from "../../services/document.service";

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {

  private id: number | null;
  private slug: string | null;

  public document: Document

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private localeObserver: LocaleObserver,
  ) {
    /* DO NOT DELETE */
    new Document();
    /* DO NOT DELETE END */

    this.route.paramMap.subscribe(
      (params) => {
        if (params.get('id')) {
          this.id = parseInt(params.get('id') || '0')
        }
        if (params.get('slug')) {
          this.slug = params.get('slug')
        }

        this.load()
      }
    )

    this.localeObserver.localeChangedObserver.subscribe(
      (locale) => {
        this.load()
      }
    )
  }

  ngOnInit(): void {
  }

  private load() {
    if (this.id && this.slug) {
      this.documentService.document(this.id, this.localeObserver.currentLocale).subscribe(
        (doc) => this.document = doc
      )
    }
  }

}
